import { useParams } from "react-router-dom"
import { useState } from "react"
import pdf from "./assets/LAVEGA.pdf"
import ModeloUsoParques from "./assets/documents/Modelo de carta utilización del espacio publico.pdf"
import ModeloUsoPlanos from "./assets/documents/Modelo de carta de tramitación de planos.pdf"
import ModeloCierreCalle from "./assets/documents/Modelo de carta cierre de calle..pdf"
import Tabla from "./components/UI/Tabla/Tabla"

export const Info = () => {
	const params = useParams()

	switch (params.id) {
		case "anteproyecto":
			return <Anteproyecto />
		case "cambio-suelo":
			return <CambioUsoSuelo />
		case "certificado-suelo":
			return <CertificadoUsoSuelo />
		case "cierre-calle":
			return <CierreRoturaCalles />
		case "demolicion":
			return <Demolicion />
		case "combustible":
			return <EstacionCombustible />
		case "proyecto-definitivo":
			return <ProyectoDefinitivo />
		case "telecomunicaciones":
			return <Telecomunicaciones />
		case "remodelacion":
			return <RemodelacionAnexo />
		case "resellado-planos":
			return <ReselladoPlanos />
		case "urbanizacion":
			return <Urbanizacion />
		case "verjas":
			return <VerjasPerimetrales />
		case "centro-Historico":
			return <CentroHistorico />
		case "uso-de-parques":
			return <UsoParques />
		case "UGAM":
			return <UGAM />
		case "uso-de-acera":
			return <UsoAcera />
		case "preferencia-de-via":
			return <PreferenciaVía />
		default:
			return <div>Información no encontrada.</div>
	}
}

export const handleOPUclick = () => {
	window.open("/opu/new", "_self")
}

export const handleDPUclick = () => {
	window.open("/dpu/new", "_self")
}

const Anteproyecto = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}

	return (
		<div className="card">
			<h2>Anteproyecto</h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Todo proyecto debe primero certificar su uso de suelo y presentar un anteproyecto
				conformado por planos arquitectónicos que permiten verificar parámetros edificatorios y
				otros requisitos a fin de obtener su aprobación; que se logra con el pago de las tasas,
				Certificado de No Objeción y el sellado de los planos.
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1(recepción de proyectos) y recibo de inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>

			<p>2. Certificación de uso de suelo.</p>
			<p>
				3. Carta dirigida al director de la Oficina de Planeamiento Urbano (OPU) solicitando la
				aprobación del anteproyecto. La carta debe incluir los metros cuadrados del solar junto
				a una breve descripción de sus edificaciones con sus m2 de construcción.
				<a className="m-2" href={ModeloUsoPlanos} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>
				4. Copia de cédula del o los propietarios (si es empresa incluir registro mercantil).
			</p>

			<p>
				5. Copia del Certificado del Título de Propiedad (de ambos lados) o acto de venta
				notarizado.
			</p>

			<p>6. Copia del plano de mensura catastral firmado por un agrimensor colegiado.</p>
			<p>
				7. Dos hojas 8.5x11” con la planta del 1er nivel dentro de la mensura, las medidas ancho
				por largo (de las edificaciones) y retiros a linderos. Deben aparecer los datos del
				propietario y dirección del inmueble.
			</p>
			<p>
				8. Certificación de Unidad de Gestión Ambiental Municipal (UGAM), en construcciones
				nuevas.
			</p>
			<p>
				9. Dos juegos de Planos Arquitectónicos impresos en 11x17”,17x22” o 24x36” encuadernados
				en formato 8.5x11” donde aparezcan mínimo:
				<ol>
					<li>Planta de localización y ubicación (que se identifique mensura y linderos).</li>
					<li> Plantas amuebladas y dimensionadas.</li>
					<li> 4 elevaciones, 2 secciones y detalles según el tipo de proyecto.</li>
				</ol>
			</p>

			<p>10. Planos Arquitectónicos en formatos digitales DWG (AutoCAD 2014 en adelante).</p>

			<p>11. Certificación emitida por el cuerpo de Bomberos.</p>
			<p>11. Pago de tasas correspondientes.</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="construcción" />}
			</div>
			<button className="process" onClick={handleDPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const CambioUsoSuelo = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}
	return (
		<div className="card">
			<h2>Cambio de Uso de Suelo</h2>

			<h3>Descripción del trámite:</h3>
			<p>
				Certificación emitida por la Oficina de Planeamiento Urbano (OPU), donde se modifican
				las actividades que pueden desarrollarse en un inmueble. La certificación puede incluir
				la validación de parámetros edificatorios (linderos, alturas, densidad, índice de
				ocupación, entre otros).
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y recibo de inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>
			<p>
				2. Carta de solicitud dirigida al director de Planeamiento Urbano (OPU), describiendo
				los fines de la solicitud y donde especifique la categoría o tipo de uso de suelo que se
				quiere certificar, la dirección del inmueble y la información del propietario o empresa
				(nombres y apellidos, números de contacto, correo electrónico, documento de identidad).
				Si es una Compañía se debe hacer la carta en hoja timbrada, verificándose su ubicación y
				RNC.
				<a className="m-2" href={ModeloUsoPlanos} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>3. Copia de cédula del dueño o representante legal del proyecto (de ambos lados).</p>
			<p>
				4. Copia del Certificado de Título de Propiedad de ambos lados o acto de venta
				notarizado.
			</p>
			<p>
				5. Copia del plano de mensura catastral o levantamiento realizado por agrimensor
				colegiado.
			</p>
			<p>
				6. Plano de localización del solar impreso en formato 8.5x11”. Deben aparecer los datos
				del propietario y dirección del inmueble.
			</p>
			<p>
				7. Memoria descriptiva en proyectos que la Oficina de Planeamiento Urbano lo requiera
				(OPU).
			</p>
			<p>8. Acto de alguacil notificando a colindantes. </p>
			<p>9. Recibo de certificación de uso de suelo (duración de un año). </p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="Cambiosdeusodesuelo" />}
			</div>
			<button className="process" onClick={handleDPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const CertificadoUsoSuelo = () => {
	return (
		<div className="card">
			<h2>Certificado de Uso de Suelo</h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Certificación emitida por la Oficina de Planeamiento Urbano (OPU), donde se especifican
				las actividades que pueden desarrollarse en un inmueble. La certificación puede incluir
				la validación de parámetros edificatorios (linderos, alturas, densidad, índice de
				ocupación, entre otros).
			</p>

			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y recibo de inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>
			<p>
				2. Carta de solicitud dirigida al director de la Oficina de Planeamiento Urbano (OPU),
				describiendo los fines de la solicitud y especificando la categoría o tipo de uso de
				suelo que se quiere certificar. Debe incluir la dirección del inmueble y la información
				del propietario o empresa (nombres y apellidos, números de contacto, correo electrónico,
				documento de identidad). Si es una compañía se debe hacer la carta en hoja timbrada,
				verificándose su ubicación y RNC.
				<a className="m-2" href={ModeloUsoParques} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>3. Copia de cédula del dueño o representante legal del proyecto (ambos lados). </p>
			<p>
				4. Copia del Certificado de Título de Propiedad de ambos lados o acto de venta
				notarizado.
			</p>
			<p>
				5. Copia del plano de mensura catastral o levantamiento realizado por agrimensor
				colegiado.
			</p>
			<p>
				6. Plano de localización del solar impreso en formato 8.5x11”. Deben aparecer los datos
				del propietario y dirección del inmueble.
			</p>
			<p>
				7. Memoria descriptiva en proyectos que la Oficina de Planeamiento Urbano lo requiera
				(OPU).
			</p>
			<p>8. Pago del tramite</p>
			<button className="process">Ver Precios</button>
			<br></br>
			<button className="process" onClick={handleOPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const CierreRoturaCalles = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}

	return (
		<div className="card">
			<h2>Cierre y Rotura de Calles</h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Para los cierres de calle a fin de: desarrollar eventos (recreación, funeral, entre
				otros), procesos de construcción (vaciados, andamios, entre otros) y excavaciones por
				averías o conexión a la infraestructura (sanitaria, pluvial, soterrado de cables y
				demás); se debe hacer una solicitud de no objeción y cumplir con unos requisitos:
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Carta dirigida al director de la Oficina de Planeamiento Urbano (OPU) solicitando la
				no objeción; especificando el propósito del cierre, si va a cerrar por completo o solo
				la mitad, nombre (o número) de la calle a cerrar, el día y la duración del cierre.
				<a className="m-2" href={ModeloCierreCalle} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>
				2. Copia de cédula del o los responsables (si es empresa incluir registro mercantil).
			</p>
			<p>
				3. Si es un evento: carta de la Junta de Vecinos o una que esté firmada por al menos dos
				(2) de las personas afectadas (incluir copias de las cédulas de identidad y electoral).
			</p>
			<p>
				4. Si implica una excavación para conectarse a la infraestructura sanitaria: depositar
				carta de la Corporación del Acueducto y Alcantarillado de La Vega (CORAAVEGA).{" "}
			</p>
			<p>5. Pagos de tasas correspondientes.</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios Cierre de Calle
				</button>
				{showTarifasRow && <Tabla tipo="Cierredecalle" />}
				{showTarifasRow && (
					<div>
						<h4>Precios Rotura de Calle</h4>
						<Tabla tipo="RoturadeCalle" />
					</div>
				)}
			</div>
			<button className="process" onClick={handleOPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const Demolicion = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}
	return (
		<div className="card">
			<h2>Demolición</h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Obtener no objeción para la demolición de edificaciones en la demarcación del
				Ayuntamiento Municipal de la Vega
			</p>

			<h3>Documentos y requerimientos:</h3>
			<p>1. Documentos de identidad.</p>
			<p>2. Cedula de identidad y/o pasaporte del propietario.</p>
			<p>
				3. Cedula de identidad y/o pasaporte del solicitante (si el solicitante no es el
				propietario).
			</p>
			<p>4. RNC de la compañía (si el propietario del título es una compañía).</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="Demolicion" />}
			</div>
			<button className="process" onClick={handleDPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const EstacionCombustible = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}
	return (
		<div className="card">
			<h2>Estaciones de Combustible</h2>
			<h3>Descripción del trámite:</h3>

			<p>
				Obtener permiso para instalar y operar una estación de expendio de combustible dentro de
				la concesión del Ayuntamiento
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>1. Documentos de identidad.</p>
			<p>2. Cedula de identidad y/o pasaporte del propietario.</p>
			<p>
				3. Cedula de identidad y/o pasaporte del solicitante (si el solicitante no es el
				propietario).
			</p>
			<p>4. RNC de la compañía (si el propietario del título es una compañía).</p>
			<p>5. Documentación de la propiedad.</p>
			<p>
				6. Título de propiedad de ambos lados (original para presentar y copia para entregar)
				legible. Si tiene gravamen traer además carta de no objeción de la entidad financiera.
				Si tiene contrato de compra y venta este debe estar firmado, notariado y registrado.
			</p>
			<p>
				7. (Copia) Plano de Mensura Catastral de la propiedad aprobada por la Dirección General
				de Mensura Catastral y firmada por un Agrimensor colegiado.
			</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="EstacionesdeCombustibles" />}
			</div>
		</div>
	)
}

const ProyectoDefinitivo = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}
	return (
		<div className="card">
			<h2>Proyecto Definitivo</h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Obtener el sellado de los planos y la firma del director luego de haber cumplido con la
				certificación de uso de suelo, la presentación y aprobación del anteproyecto y pagadas
				las tasas correspondientes.
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y Recibo de Inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>
			<p>2. Certificación de uso de suelo.</p>
			<p>3. Certificación de la Unidad de Gestión Ambiental Municipal (UGAM).</p>
			<p>
				4.Carta dirigida al director de la Oficina de Planeamiento Urbano (OPU) solicitando la
				aprobación.
				<a className="m-2" href={ModeloUsoPlanos} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>
				5. Copia de cédula del o los propietarios (si es empresa incluir registro mercantil).
			</p>
			<p>
				6. Copia del Título de Propiedad (de ambos lados), si solo dispone de un acto de venta
				debe de estar notarizado y registrado, y si tiene gravamen, traer carta de no objeción.
			</p>
			<p>
				7. Copia del plano de mensura catastral firmado por un agrimensor colegiado y revisado
				por la Dirección General de Mensura Catastral.
			</p>
			<p>8. Ficha Técnica (F-3), del Ministerio de Obras Públicas y Comunicaciones (MOPC). </p>
			<p>
				9. Dos juegos de planos definitivos impresos en 11x17”,17x22” o 24x36” encuadernados en
				formato 8.5x11” donde aparezcan mínimo:
				<ol>
					<li>Planta de localización y ubicación (que se identifique mensura y linderos). </li>
					<li>Plantas amuebladas y dimensionadas.</li>
					<li>4 elevaciones, 2 secciones y detalles según el tipo de proyecto. </li>
				</ol>
			</p>
			<p>10. Planos definitivos en formatos digitales DWG (AutoCAD 2014 en adelante). </p>
			<p>11. Pago de tasas correspondientes.</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="construcción" />}
			</div>
			<button className="process" onClick={handleDPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const Telecomunicaciones = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}
	return (
		<div className="card">
			<h2>Redes de Telecomunicaciones</h2>

			<h3>Descripción del trámite:</h3>
			<p>
				El despliegue de redes de telecomunicaciones es regulado por el Ayuntamiento, por lo que
				para su ejecución se debe solicitar la no objeción de dichas instalaciones y cumplir con
				los siguientes requisitos:
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y recibo de inspección de la oficina de
				planeamiento urbano (OPU).
			</p>
			<p>
				2. Carta dirigida al director de la Oficina de Planeamiento Urbano (OPU) solicitando la
				no objeción a la instalación. Debe incluir una descripción del proyecto (metros
				lineales, postes, entre otros).
				<a className="m-2" href={ModeloUsoParques} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>
				3. Copia de cédula del o los propietarios (si es empresa incluir registro mercantil).
			</p>
			<p>4. Certificación de la Unidad de Gestión Ambiental Municipal (UGAM). </p>

			<p>5. Licencia del Instituto Dominicano de las Telecomunicaciones (INDOTEL).</p>
			<p>
				6. Plano mostrando la localización, ubicación y trayectoria (8.5x11”, 11x17” o 17x22”).{" "}
			</p>
			<p>7. Pago de tasas correspondientes.</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="RedesdeTelecomunicaciones" />}
			</div>
			<button className="process" onClick={handleOPUclick}>
				Solicitar trámite
			</button>
			<div>
				<br></br>
				<h2>Torres de Telecomunicaciones</h2>
				<h3>Descripción del trámite:</h3>
				<p>Obtener la no objeción a la instalación de torres de telecomunicaciones</p>
				<h3>Documentos y requerimientos:</h3>
				<p>
					1. Formulario R1 (recepción de proyectos) y recibo de inspección de la oficina de
					planeamiento urbano (OPU).
				</p>
				<p>2. Formulario de tramitación de planos debidamente llenado.</p>
				<p>3. Certificado de uso de suelo.</p>
				<p>4. Memoria descriptiva.</p>
				<p>
					5. Copia del título de propiedad (de ambos lados) y un acto de venta notarizado (en
					caso de requerirlo) y el contrato de arrendamiento (si no es el propietario).
				</p>
				<p>
					6. Copia de cedula de los propietarios (si es empresa incluir registro mercantil).
				</p>

				<p>7. Certificación de la unidad de gestión ambiental (UGAM).</p>
				<p>8. Licencia del instituto Dominicano de las Telecomunicaciones (INDOTEL).</p>
				<p>9. Permiso del Instituto Dominicano de Aviación (IDAC).</p>

				<p>10. Carta de no objeción de la junta de vecinos.</p>

				<p>11. Planta de localización, ubicación del proyecto (mostrando solo techos).</p>
				<p>
					12. Dos juegos de planos arquitectónicos impresos 11x17”, 17x22” o 24x26”
					encuadernados en formato 8.5x11” donde aparezca mínimo:
				</p>

				<p>13. Pagos de tasas correspondientes.</p>
				<div>
					<button className="process" onClick={handleButtonClick}>
						Ver Precios
					</button>
					{showTarifasRow && <Tabla tipo="TorresTelecomunicacionesAntena" />}
				</div>
			</div>
			<button className="process" onClick={handleOPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const RemodelacionAnexo = () => {
	return (
		<div className="card">
			<h2>Remodelación y Reconstrución</h2>
			<h2>Descripción del trámite:</h2>
			<p>
				Para remodelar o agregar un anexo a una edificación existente, el proceso de tramitación
				será el mismo utilizado para anteproyecto (Art.10). Aplicándose las tasas
				correspondientes a la parte a remodelar y/o anexar. La parte existente que no se va a
				intervenir, debe aparecer solo a modo de referencia en los planos arquitectónicos
				depositados.
			</p>
			<h2>Documentos y requerimientos:</h2>

			<p>
				1. Carta solicitud dirigida al directo de Planeamiento Urbano.
				<a className="m-2" href={ModeloUsoPlanos} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>2. Copia de cédula de identidad.</p>
			<p>3. Traer Título de Propiedad, copia de ambas caras o Acto de Venta.</p>
			<p>
				4. Copia del Plano de Mensura Catastral revisado por la dirección General de Mensura
				Catastral.
			</p>
			<p>
				5. Juegos de Planos Arquitectónicos en <b>formato 11"x17" o 24"x36"</b>, A ESCALA.
				<ol>
					<li>Plano de Localización y Ubicación.</li>
					<li>Planta de conjunto indicando retiros a linderos.</li>
					<li>Planta dimensionada.</li>
					<li>Levantamiento Fotográfico del área a Remodelar.</li>
				</ol>
			</p>
			<p>6. Pago de tasas correspondientes.</p>
			<p>
				<b>Nota:</b>
			</p>
			<p>
				El juego de plano debe contener Las firmas del propietario No. De cédula y de los
				profesionales involucrados.
			</p>
			<p>
				En proyectos especiales como Estaciones de combustible, gas, edificaciones para plazas
				comerciales, entre otros proyectos que afecten la morfologia del entono la certificación
				de no objeción tendrá un costo que se indicara luego de conocerse el anteproyecto.
			</p>
			<p>No depositar si no cumple con todos estos requisitos.</p>
			<button className="process">Ver Precios</button>
			<br></br>
			<button className="process" onClick={handleDPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const ReselladoPlanos = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}
	return (
		<div className="card">
			<h2>Resellado de Planos</h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Los anteproyectos y proyectos previamente aprobados por la Oficina de Planeamiento
				Urbano (OPU), podrán solicitar el resellado de planos.
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>1. Depósito de juegos de planos para ser sellados.</p>
			<p>2. Pagos correspondientes.</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="ReselladodePlanos" />}
			</div>
		</div>
	)
}

const Urbanizacion = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}

	return (
		<div className="card">
			<h2>Urbanizacion</h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Para urbanizar un terreno, se debe certificar su uso de suelo (Art. 8) y someter una
				serie de planos y documentos a fin de describir el proyecto y cumplir con una serie de
				requisitos:
			</p>

			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y recibo de inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>
			<p>2. Formulario de tramitación de planos debidamente llenado. </p>
			<p>3. Certificación de uso de suelo.</p>
			<p>
				4. Carta dirigida al director de la Oficina de Planeamiento Urbano (OPU) solicitando la
				aprobación de la urbanización: indicando los m2 del solar y el porcentaje de cada una de
				sus áreas.
				<a className="m-2" href={ModeloUsoPlanos} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>5. Memoria descriptiva.</p>
			<p>
				6. Copia de cédula del o los propietarios (si es empresa incluir registro mercantil).
			</p>
			<p>
				7. Copia del Título de Propiedad (de ambos lados), si lo acompaña un acto de venta debe
				de estar notarizado y registrado, y si tiene gravamen, traer carta de no objeción.
			</p>
			<p>
				8. Copia del plano de mensura catastral firmado por un agrimensor colegiado y revisado
				por la Dirección General de Mensura Catastral.
			</p>
			<p>9. Certificación de la Unidad de Gestión Ambiental Municipal (UGAM).</p>
			<p>
				10. Acto Notarial de renuncia del (siete) 7% mínimo (5% de áreas verdes + 2% de área
				verde Institucional), junto a un plano catastral con los requerimientos de catastro.
			</p>
			<p>
				11. Dos o más, juegos de planos en formato 24x36” donde aparezca mínimo:
				<ol>
					<li>Planta de localización y ubicación, entorno inmediato y conexiones viales. </li>
					<li>
						Planta de lotificación indicando los nombres de calles, manzanas, numeración de
						solares y descripción de los usos de suelo propuestos.
					</li>
					<li>
						Planta de lotificación indicando áreas verdes, institucionales, retiros de
						edificaciones a los linderos.
					</li>
					<li>
						Tabla que indique el metraje y porcentaje de las áreas (calles, solares
						residenciales, área comercial, área verde, área institucional, entre otros).
					</li>
					<li>Plano topográfico con la lotificación sobre las curvas de nivel. </li>
					<li>
						Paisajismo (árboles, parques, jardines, modificaciones topográficas, entre otros).
					</li>
					<li>Detalle de linderos mínimos propuestos y solares tipo. </li>
					<li>
						Trazado vial: secciones, ejes, radios, pendientes y longitudes de vías; estudio de
						suelo, diseño de pavimento y detalles incluido el de Cul-de-sac.
					</li>
					<li>
						Instalaciones Sanitarias: Drenaje Pluvial (imbornales, tuberías, badenes, entre
						otros), agua potable y aguas residuales (coordinar con la Corporación del
						Acueducto y Alcantarillado de La Vega CORAAVEGA).
					</li>
					<li>Instalaciones eléctricas: líneas eléctricas, iluminación y detalles. </li>
					<li>
						Planos arquitectónicos de la entrada al proyecto y de cada edificación (plantas
						amuebladas y dimensionadas, 4 elevaciones, 2 secciones y detalles).
					</li>
				</ol>
			</p>
			<p>12. Planos definitivos en formatos digitales DWG (AutoCAD 2014 en adelante).</p>
			<p>13. Pago de tasas correspondientes.</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="construcción" />}
			</div>
			<button className="process" onClick={handleDPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const VerjasPerimetrales = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}
	return (
		<div className="card">
			<h2>Verjas</h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Obtener no objeción para la edificación de verjas perimetrales en la demarcación del
				Ayuntamiento Municipal de la Vega
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>1. Cédula de identidad y/o pasaporte del propietario.</p>
			<p>
				2. Cédula de identidad y/o pasaporte del solicitante (si el solicitante no es el
				propietario).
			</p>
			<p>
				3. RNC de la compañía (si el propietario del título es una compañía) Documentación de la
				propiedad.
			</p>
			<p>
				4. Título de propiedad de ambos lados (original para presentar y copia para entregar)
				legible. Si tiene gravamen traer además carta de no objeción de la entidad financiera.
				Si tiene contrato de compra y venta este debe estar firmado, notariado y registrado.
			</p>
			<p>
				5. (Copia) Plano de Mensura Catastral de la propiedad aprobada por la Dirección General
				de Mensura Catastral y firmada por un Agrimensor colegiado.
			</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="Especiales" />}
			</div>
			<button className="process" onClick={handleDPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const CentroHistorico = () => {
	return (
		<div className="card">
			<h2>PROTOCOLO DE TRAMITACIÓN EN EL CENTRO HISTÓRICO DE LA VEGA </h2>
			<h3>Descripción del trámite:</h3>
			<p>
				Amparados en la Ley No. 176-07 del Distrito Nacional y los Municipios en su artículo 19
				sobre Competencias Propias del Ayuntamiento, en su acápite h, sobre la preservación del
				patrimonio histórico y cultural del municipio, se ha emitido en el Ayuntamiento de La
				Vega la Ordenanza No 013-2021 Sobre el uso de Suelo, Trámites y Tasas de Planeamiento
				Urbano. En el Título III de Trámites, Tarifas y Penalidades, en su Capítulo I, Art. 9,
				Párrafo 4: expresa que “Toda Intervención dentro del Centro Histórico deberá dejarse
				acompañar de la Oficina de Planeamiento Urbano (OPU) a fin de obtener un diseño que no
				afecte el conjunto resguardado como patrimonio Histórico Cultural” por lo cual se
				presenta el protocolo de acción.
			</p>
			<h3>Criterios de evaluación:</h3>
			<p>
				1. Tipo de intervención del inmueble.
				<ol typeof="A">
					<li>Restauración</li>
					<li>Conservación</li>
					<li>Remodelación</li>
				</ol>
			</p>
			<p>2. Categoría del inmueble dentro del Centro Histórico de La Vega (CHLV).</p>
			<p>3. Tratamiento de los elementos arquitectónicos identitarios.</p>
			<p>4. Tipos de anexo a construir.</p>
			<p>5. Adecuación al entorno del Centro Histórico de La Vega (CHLV).</p>
			<p>
				6. Propuesta de colores según la Guía del uso del color en los Centros Históricos de la
				Dirección Nacional de Patrimonio Monumental.
			</p>
			<p>
				7. Normativa interna del Manual de Publicidad Exterior Visual para el Centro Histórico.
			</p>
			<br></br>
			<h3>Presentar los siguientes documentos digitales:</h3>
			<p>
				1. Levantamiento edificación actual:
				<ul>
					<li>
						i. Localización en el plano de la ciudad y ubicación en el lote correspondiente.
					</li>
					<li>ii. Plantas arquitectónicas amuebladas y dimensionadas.</li>
					<li>iii. Elevaciones iv. Secciones</li>
					<li>v. Fotos del entorno inmediato, lateral y frontal.</li>
				</ul>
				<p>
					b. Propuesta a implementar:
					<ul>
						<li>i. Amuebladas</li>
						<li>ii. Dimensionadas</li>
						<li>iii. De remodelación.</li>
						<li>iv. Elevaciones a color.</li>
						<li>v. Secciones.</li>
					</ul>
				</p>
				<p>c. Presentación 3D (opcional).</p>
				<p>
					d. Montaje de la intervención en el contexto inmediato. <strong>Nota:</strong> La OPU
					cuenta con perfiles fotográficos digitales que se pueden facilitar para este
					requerimiento.
				</p>
				<p>
					e. En caso de intervención de restauración presentar informe técnico de tratamiento
					de las obsolencias diagnosticadas.
				</p>
			</p>
			<p>
				2. Luego de ser entregados todos los documentos solicitados se procede a la evaluación
				por parte de la OPU con la asesoría de la Dirección Regional de Patrimonio que emiten
				comentarios de mejora según los criterios de evaluación.
			</p>
			<p>
				3. Una vez remitidos las correcciones por parte de la OPU el proyectista debe aplicar lo
				recomendado y volver a enviar los mismos documentos con los cambios de lugar.
			</p>
			<p>
				4. El proceso 2 y 3 se repite tantas veces como sea necesario hasta que la propuesta se
				adecúe con el entorno lo que se ratifica con la emisión de la Certificación de No
				Objeción Patrimonial. <strong>Nota:</strong> Esta certificación es de uso interno de la
				OPU, como un aval de que ha culminado satisfactoriamente el proceso patrimonial.
			</p>
			<p>
				5. Al ser completados satisfactoriamente los requerimientos y ser emitida la
				Certificación de no objeción, se procede a la tramitación regular del proyecto.
			</p>
			<br></br>
			<h4>Nota:</h4>
			<p>
				<ul>
					<li>Ningún proyecto será recibido sin la documentación completa.</li>
					<li>
						Todos los planos deben estar firmados por el arquitecto responsable del proyecto,
						miembro del CODIA, y el propietario del inmueble.
					</li>

					<li>
						Las solicitudes de demolición deben cumplir con el protocolo correspondiente y
						estar acompañadas de un levantamiento arquitectónico detallado de la propiedad
						existente, con estudio fotográfico, impreso y en digital .DWG
					</li>
					<li>
						La No Objeción al anteproyecto de parte de nuestra dirección será emitida
						posteriormente a la aprobación en la Dirección Nacional de Patrimonio Monumental
						(DNPM).
					</li>
					<li>
						El proyectista debe notificar ante esta institución y a la DNPM, el inicio de
						obras.
					</li>
					<li>
						Los proyectos recibirán acompañamiento de la OPU en su fase de ejecución para
						velar por las disposiciones aprobadas.
					</li>
				</ul>
			</p>
			<button className="process">Ver Precios</button>
			<br></br>
			<button className="process" onClick={handleDPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const UsoParques = () => {
	const [showTarifasRow, setShowTarifasRow] = useState(false)

	const handleButtonClick = () => {
		setShowTarifasRow(!showTarifasRow)
	}
	return (
		<div className="card">
			<h2>Uso de Parques</h2>
			<p>
				El uso de los parques y áreas verdes de la ciudad es de libre acceso para todos los
				veguenses y visitantes, sin embargo, se debe tener en cuenta que el uso de estos
				espacios debe ser respetuoso con el entorno y con las personas que los utilizan.
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y recibo de inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>
			<p>
				2. Carta de solicitud dirigida al director de la Oficina de Planeamiento Urbano (OPU),
				describiendo los fines de la solicitud y especificando la categoría o tipo de uso de
				suelo que se quiere certificar. Debe incluir la dirección del inmueble y la información
				del propietario o empresa (nombres y apellidos, números de contacto, correo electrónico,
				documento de identidad). Si es una compañía se debe hacer la carta en hoja timbrada,
				verificándose su ubicación y RNC.
				<a className="m-2" href={ModeloUsoParques} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>3. Copia de cédula del dueño o representante legal del proyecto (ambos lados). </p>
			<p>
				4. Copia del Certificado de Título de Propiedad de ambos lados o acto de venta
				notarizado.
			</p>
			<p>
				5. Copia del plano de mensura catastral o levantamiento realizado por agrimensor
				colegiado.
			</p>
			<p>
				6. Plano de localización del solar impreso en formato 8.5x11”. Deben aparecer los datos
				del propietario y dirección del inmueble.
			</p>
			<p>
				7. Memoria descriptiva en proyectos que la Oficina de Planeamiento Urbano lo requiera
				(OPU).
			</p>
			<p>8. Pago del tramite</p>
			<div>
				<button className="process" onClick={handleButtonClick}>
					Ver Precios
				</button>
				{showTarifasRow && <Tabla tipo="usoParques" />}
			</div>
			<button className="process" onClick={handleOPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const UGAM = () => {
	return (
		<div className="card">
			<h2>Certificado UGAM</h2>
			<p>
				Este tramite es para permisos de limpieza de solar, poda de árboles, y cualquier
				proyecto que tenga que ver con la remoción de la capa vegetal.
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y recibo de inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>
			<p>
				2. Carta de solicitud dirigida al director de la Oficina de Planeamiento Urbano (OPU),
				describiendo los fines de la solicitud y especificando la categoría o tipo de uso de
				suelo que se quiere certificar. Debe incluir la dirección del inmueble y la información
				del propietario o empresa (nombres y apellidos, números de contacto, correo electrónico,
				documento de identidad). Si es una compañía se debe hacer la carta en hoja timbrada,
				verificándose su ubicación y RNC.
				<a className="m-2" href={ModeloUsoParques} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>3. Copia de cédula del dueño o representante legal del proyecto (ambos lados). </p>
			<p>
				4. Copia del Certificado de Título de Propiedad de ambos lados o acto de venta
				notarizado.
			</p>
			<p>
				5. Copia del plano de mensura catastral o levantamiento realizado por agrimensor
				colegiado.
			</p>
			<p>
				6. Plano de localización del solar impreso en formato 8.5x11”. Deben aparecer los datos
				del propietario y dirección del inmueble.
			</p>
			<p>
				7. Memoria descriptiva en proyectos que la Oficina de Planeamiento Urbano lo requiera
				(OPU).
			</p>
			<p>8. Pago del tramite</p>
			<button className="process" onClick={handleOPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const UsoAcera = () => {
	return (
		<div className="card">
			<h2>Uso de acera</h2>
			<p>
				Con el fin de utilización para colocación de andamios para arreglar cualquier fachada,
				para utilización en general.
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y recibo de inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>
			<p>
				2. Carta de solicitud dirigida al director de la Oficina de Planeamiento Urbano (OPU),
				describiendo los fines de la solicitud y especificando la categoría o tipo de uso de
				suelo que se quiere certificar. Debe incluir la dirección del inmueble y la información
				del propietario o empresa (nombres y apellidos, números de contacto, correo electrónico,
				documento de identidad). Si es una compañía se debe hacer la carta en hoja timbrada,
				verificándose su ubicación y RNC.
				<a className="m-2" href={ModeloUsoParques} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>3. Copia de cédula del dueño o representante legal del proyecto (ambos lados). </p>
			<p>
				4. Copia del Certificado de Título de Propiedad de ambos lados o acto de venta
				notarizado.
			</p>
			<p>
				5. Copia del plano de mensura catastral o levantamiento realizado por agrimensor
				colegiado.
			</p>
			<p>
				6. Plano de localización del solar impreso en formato 8.5x11”. Deben aparecer los datos
				del propietario y dirección del inmueble.
			</p>
			<p>
				7. Memoria descriptiva en proyectos que la Oficina de Planeamiento Urbano lo requiera
				(OPU).
			</p>
			<p>8. Pago del tramite</p>
			<button className="process" onClick={handleOPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}

const PreferenciaVía = () => {
	return (
		<div className="card">
			<h2>Preferencia de vía</h2>
			<p>
				Los abogados o jueces que necesiten saber cual es la vía preferencial ya sea por algún
				accidente ocurrido o porque no este señalizada correctamente.
			</p>
			<h3>Documentos y requerimientos:</h3>
			<p>
				1. Formulario R1 (recepción de proyectos) y recibo de inspección de la Oficina de
				Planeamiento Urbano (OPU).
			</p>
			<p>
				2. Carta de solicitud dirigida al director de la Oficina de Planeamiento Urbano (OPU),
				describiendo los fines de la solicitud y especificando la categoría o tipo de uso de
				suelo que se quiere certificar. Debe incluir la dirección del inmueble y la información
				del propietario o empresa (nombres y apellidos, números de contacto, correo electrónico,
				documento de identidad). Si es una compañía se debe hacer la carta en hoja timbrada,
				verificándose su ubicación y RNC.
				<a className="m-2" href={ModeloUsoParques} download>
					<i className="fa-solid fa-file-pdf fa-2x text-red-600"></i>
				</a>
			</p>
			<p>3. Copia de cédula del dueño o representante legal del proyecto (ambos lados). </p>
			<p>
				4. Copia del Certificado de Título de Propiedad de ambos lados o acto de venta
				notarizado.
			</p>
			<p>
				5. Copia del plano de mensura catastral o levantamiento realizado por agrimensor
				colegiado.
			</p>
			<p>
				6. Plano de localización del solar impreso en formato 8.5x11”. Deben aparecer los datos
				del propietario y dirección del inmueble.
			</p>
			<p>
				7. Memoria descriptiva en proyectos que la Oficina de Planeamiento Urbano lo requiera
				(OPU).
			</p>
			<p>8. Pago del tramite</p>
			<button className="process" onClick={handleOPUclick}>
				Solicitar trámite
			</button>
		</div>
	)
}
